import type { NodeId, Point } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { closeEdgeContextMenu } from '../edges/closeEdgeContextMenu';

export interface OpenNodeContextMenuCommand {
  nodeId: NodeId;
  position: Point;
}

export const openNodeContextMenu: GraphCommandFactory<
  OpenNodeContextMenuCommand
> = (cmdContext, dispatch) => (command) => {
  cmdContext.updateState((draft) => {
    draft.nodeContextMenu = command;
  });

  dispatch(closeEdgeContextMenu);
};
